<template>
    <div v-if="task.output">
        <div class="tasks-bar-buttons">
            <a :href="task.output.csvUrl" target="_blank" @click="done()">
                <i class="fa-file"></i>
                CSV
            </a>
            <a :href="task.output.xlsxUrl" target="_blank" v-tooltip title="Excel 2007 ou superior" @click="done()">
                <i class="fa-file"></i>
                Excel
            </a>
            <a :href="task.output.jsonUrl" target="_blank" @click="done()">
                <i class="fa-file"></i>
                JSON
            </a>
            <a :href="task.output.xmlUrl" target="_blank" @click="done()">
                <i class="fa-file"></i>
                XML
            </a>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            task: {
                type: Object
            },
            done: {
                type: Function
            }
        }
    }
</script>


// WEBPACK FOOTER //
// ExportCustomersV1.vue?58d30ee5